// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Filters{width:100%}.Filters__field{padding-bottom:30px}", "",{"version":3,"sources":["webpack://./src/styles/components/Filters.scss"],"names":[],"mappings":"AAAA,SACE,UAAA,CAEA,gBACE,mBAAA","sourcesContent":[".Filters {\n  width: 100%;\n\n  &__field {\n    padding-bottom: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
